import React, { useState } from 'react';
import { storeGetOrDefault, storeSet, DEF_SETTINGS } from '../../store';
import '../admin.css';

const Toast = ({ msg, type }) => msg ? <div className={`adm-toast adm-toast-${type}`}>{msg}</div> : null;

// NOTE: Section & Field are declared at module scope (not inside the component).
// Defining them inside the component made React treat each render's <Field/> as a
// brand-new component type, causing the <input> to unmount/remount on every keystroke
// → the field lost focus after one character (couldn't type or paste).
const Section = ({ title, children }) => (
  <div className='adm-settings-card'>
    <h3 className='adm-settings-card-title'>{title}</h3>
    <div className='adm-form' style={{ gap: 14 }}>
      {children}
    </div>
  </div>
);

const Field = ({ label, k, cfg, onChange, type = 'text', placeholder = '', hint }) => (
  <div className='adm-form-group'>
    <label className='adm-label'>{label}</label>
    <input className='adm-input' type={type} value={cfg[k] || ''} onChange={onChange(k)} placeholder={placeholder} />
    {hint && <p className='adm-hint'>{hint}</p>}
  </div>
);

const ContactAdmin = () => {
  const [cfg, setCfg] = useState(() => storeGetOrDefault('settings', DEF_SETTINGS));
  const [toast, setToast] = useState({ msg: '', type: 'success' });

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast({ msg: '', type: 'success' }), 3000);
  };

  const f = (k) => (e) => setCfg(c => ({ ...c, [k]: e.target.value }));

  const handleSave = (e) => {
    e.preventDefault();
    storeSet('settings', cfg);
    showToast('Contact information saved!');
  };

  return (
    <div className='adm-page'>
      <Toast {...toast} />

      <div className='adm-page-hero'>
        <div className='adm-page-hero-icon' style={{ background: 'linear-gradient(135deg,#2878c4,#1a5fa3)' }}>
          <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#fff' strokeWidth='2'>
            <path d='M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z'/>
          </svg>
        </div>
        <div>
          <h1 className='adm-title'>Contact Us</h1>
          <p className='adm-subtitle'>Manage contact page information, phone numbers, email addresses and social links</p>
        </div>
      </div>

      <form onSubmit={handleSave}>
        <div className='adm-settings-grid'>
          <Section title='📍 Office Addresses'>
            <Field cfg={cfg} onChange={f} label='HQ Address' k='hqAddress' placeholder='Street, City, State PIN' />
            <Field cfg={cfg} onChange={f} label='HQ Phone' k='hqPhone' placeholder='+91 22 XXXX XXXX' />
            <Field cfg={cfg} onChange={f} label='Godown / Factory Address' k='godownAddress' placeholder='Plot, MIDC, District' />
            <Field cfg={cfg} onChange={f} label='Godown Phone' k='godownPhone' placeholder='+91 XXX XXXX XXXX' />
          </Section>

          <Section title='📞 Contact Numbers & Email'>
            <div className='adm-form-row'>
              <Field cfg={cfg} onChange={f} label='Primary Phone' k='phone' placeholder='+91 XXXX XXXX' />
              <Field cfg={cfg} onChange={f} label='Alternate Phone' k='altPhone' placeholder='+91 XXXX XXXX' />
            </div>
            <div className='adm-form-row'>
              <Field cfg={cfg} onChange={f} label='Primary Email' k='email' type='email' placeholder='info@domain.com' />
              <Field cfg={cfg} onChange={f} label='Alternate Email' k='altEmail' type='email' placeholder='sales@domain.com' />
            </div>
            <Field cfg={cfg} onChange={f} label='Business Hours' k='businessHours' placeholder='Mon – Sat: 9 AM – 6 PM IST' hint='Shown on contact page and footer' />
          </Section>

          <Section title='🔗 Social Media Links'>
            <Field cfg={cfg} onChange={f} label='WhatsApp Link' k='whatsapp' placeholder='https://api.whatsapp.com/send?phone=91XXXXXXXXXX' />
            <Field cfg={cfg} onChange={f} label='LinkedIn URL' k='linkedin' placeholder='https://www.linkedin.com/company/...' />
            <Field cfg={cfg} onChange={f} label='Facebook URL' k='facebook' placeholder='https://www.facebook.com/...' />
            <Field cfg={cfg} onChange={f} label='Instagram URL' k='instagram' placeholder='https://www.instagram.com/...' />
          </Section>
        </div>

        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
          <button type='submit' className='adm-btn adm-btn-primary' style={{ padding: '12px 36px', fontSize: '1rem' }}>
            Save Contact Info
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactAdmin;
